export const SUPPORT_EMAIL = "pvlsmediamanagement@amazon.com";
